module.exports = __webpack_public_path__ + "img/Home-3.33b6120c.jpg";